/**
 * Bộ công cụ mô phỏng LINQ C# cho JavaScript
 * Sử dụng Map để tối ưu hiệu năng và an toàn cho mọi trình duyệt
 */

export const LINQ = {
    // Tương đương .ToLookup()
    toLookup: (array, keySelector) => {
        if (!Array.isArray(array)) return new Map();
        return array.reduce((map, item) => {
            const key = keySelector(item);
            if (!map.has(key)) map.set(key, []);
            map.get(key).push(item);
            return map;
        }, new Map());
    },

    // Tương đương .FirstOrDefault()
    firstOrDefault: (array, predicate, defaultValue = null) =>
        array.find(predicate) || defaultValue,

    // Tương đương .SelectMany() - làm phẳng mảng
    selectMany: (array, selector) => array.flatMap(selector),

    // Tương đương .Distinct()
    distinct: (array, selector = (item) => item) => {
        const seen = new Set();
        return array.filter((item) => {
            const k = selector(item);
            return seen.has(k) ? false : seen.add(k);
        });
    },
};
